<template>
  <div id='' class='' v-loading='loading'>

    <bdialog :config='bconfig'></bdialog>

    <el-button v-show='userType == 0'  type='primary' @click='addVer'>{{$t('app_addver')}}</el-button>


    <div>
      <el-card class="box-card gTopMg vcard" v-for='item,index in tableData' :key="index">
        <div slot="header" class="clearfix">
          <span class='vcardtt' style="line-height: 36px;">{{item.version}}</span>
          <span class='vcardtt' style="line-height: 36px;float:right;">
            {{item.opetime}}
          </span>
          <span style="line-height: 36px;float:right;margin-right:16px;">
            <el-button  v-show='userType == 0 && index == 0' type=text @click='editVer(item)'><i class="fa fa-pencil" style="color:rgb(72,87,106)"></i></el-button>
          </span>
          <span style="line-height: 36px;float:right;margin-right:16px;">
            <el-button v-show='userType == 0' type='text' @click='delVer(item)'><i class="fa fa-trash-o" style="color:rgb(72,87,106)"></i></el-button>
          </span>
        </div>
        <div   id="markdownBody" v-html='item.memo'></div>
        
      </el-card>

    </div>

  </div>
</template>

<style >
  /* html,body{width:100%;height:100%;}*/

  .tbPoint td{cursor:pointer}

  .vcard {

  }
  .vcardtt {
    font-size:16px;
    font-weight:bold;
    color:rgba(72,87,106,1);
  }

  .cmMarginFrame{width:calc(100% - 20px);height:100%;background:none;margin-left:10px;}

  #appDepot{min-width:840px;}

  #adData{}





</style>

<script>
  // import MechanismSelector from '@/components/global/mechanism_selector.vue'
  import bdialog from './bdialog'
  export default{
    components: {
      bdialog
    },
    data () {
      var that = this
      return {
        userType: this.$getWObj().login.userType,
        bconfig: '',
        htmlexp: "",
        orderName: '',
        orderType: '',
        total: 0,
        index: 1,
        dvTotal: 0,
        loading: 0,
        appType: '',
        queryKey: ''
      }
    },
    computed: {
    
      
    },
    methods: {
      
      sortChange (vl) {
        switch (vl.prop) {
          case 'createTime':
            this.orderName = '2'
            break
        }
        this.orderType = vl.order == 'descending'? 'desc':'asc'
        this.getList()
      },
      editVer (row) {
        var _this = this
        this.bconfig = {
          type: 0,
          edit: true,
          id: row.id,
          vinfo: '',
          binfo: '',
          callback: () => {
            _this.getList()
          }
        }
      },
      query () {
        this.getList()
      },
      selectChange (vl) {
        this.selectMid = vl
        this.getList()
      },
      pageSelect (index) {
        this.index = index
        this.getList()
      },
      
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
      delVer (obj) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_isDelData'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.$delUdVer(obj.id, res => {
            if (res.status === 200) {
              this.getList()
              this.$message.success(res.message)
            } else {
              this.$message.error(res.message)
            }
          }, '')
        }, '')
      },
      
      addVer () {
        var _this = this
        this.bconfig = {
          type: 0,
          edit: false,
          vinfo: '',
          binfo: '',
          callback: () => {
            _this.getList()
          }
        }
      },
      getList () {
        this.loading = 1
        // var dsid = this.selectMid ? this.selectMid : '' //渠道商id
        // var name = this.queryKey ? this.queryKey : ''

        this.$udVerList(this.index, this.$gRow, (res) => {
      
          this.loading = 0
          if (res.status === 200) {
            this.total = res.total
            this.tableData = res.data
          } else {
            this.$message(res.message)
          }
        }, () => {
          this.loading = 0
          this.$message.error(this.$t('app_rqsError'))
        })
      }
    },
    mounted () {
      
      // this.bconfig = {
      //   type: 2,
      //   vinfo: {
      //     title: '1.3.9',
      //     content: this.htmlexp
      //   },
      //   binfo: {
      //     title: 'hello',
      //     content: this.htmlexp
      //   },
      //   callback: () => {
      //     alert('callback')
      //   }
      // }

      this.getList()
    },
    destroyed () {
    }
  }
</script>



// WEBPACK FOOTER //
// vlist.vue?42b36d42